import React from 'react';
import { motion } from 'framer-motion';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import BoltIcon from '@mui/icons-material/Bolt';
import { LeadForm } from './LeadForm';
import { AnimatedBackground } from './AnimatedBackground';
import { CountUp } from './motion/CountUp';
const stats = [{
  value: '7',
  label: 'Días entrega'
}, {
  value: '$600',
  label: 'Desde'
}, {
  value: '100+',
  label: 'Negocios'
}];
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function Hero() {
  return <section id="inicio" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-[linear-gradient(135deg,#071F5C_0%,#0A2E8C_50%,#1B4DCC_100%)] px-6 pb-24 pt-32" data-id="element-73" data-mp="nbonp2apio2e">
      <AnimatedBackground sweep icons data-id="element-74" data-mp="384jt6yzotjsx" />

      <div className="relative z-10 grid w-full max-w-[1100px] grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-75" data-mp="3j7zgfm2d3yi9">
        <motion.div variants={container} initial="hidden" animate="show" data-id="element-76" data-mp="3o6kh1mlj0k78">
          <motion.div variants={item} className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand-yellow/40 bg-brand-yellow/15 px-4 py-2 text-[13px] font-semibold text-brand-yellow backdrop-blur-sm" data-id="element-77" data-mp="39aupza1hhgvn">
            <span className="h-2 w-2 animate-pulse-dot rounded-full bg-brand-yellow" data-id="element-78" data-mp="30fy87t3p6vw6" />
            Webs listas en 7 días garantizados
          </motion.div>

          <motion.h1 variants={item} className="mb-5 font-display text-[clamp(36px,5vw,58px)] font-extrabold leading-[1.1] tracking-[-1px] text-white" data-id="element-79" data-mp="2qkmv1f7xtwqj">
            Tu Negocio
            <br data-id="element-80" data-mp="2hkgibvk2d0sf" />
            Merece Ser
            <br data-id="element-81" data-mp="2hlj8u2dh517t" />
            <span className="relative inline-block text-brand-yellow" data-id="element-82" data-mp="2lkimcbd9u6av">
              Encontrado
              <motion.span aria-hidden="true" initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              duration: 0.8,
              delay: 0.9,
              ease: [0.16, 1, 0.3, 1]
            }} className="absolute -bottom-1 left-0 right-0 h-[3px] origin-left rounded-sm bg-brand-yellow" data-id="element-83" data-mp="s21k8hdb6o2m" />
            </span>
          </motion.h1>

          <motion.p variants={item} className="mb-8 max-w-[480px] text-lg leading-relaxed text-white/80" data-id="element-84" data-mp="1b04bz3x8qz44">
            Creamos páginas web profesionales para negocios locales que aparecen
            en Google, generan confianza y convierten visitantes en clientes
            reales.
          </motion.p>

          <motion.dl variants={item} className="flex items-stretch gap-6" data-id="element-85" data-mp="3lsp33cogahdw">
            {stats.map((stat, index) => <React.Fragment key={stat.label} data-id="element-86" data-mp="3hr3rdunnk95a" data-mpi={index}>
                {index > 0 ? <div aria-hidden="true" className="w-px bg-white/20" data-id="element-87" data-mp="1x9ks4fme6se1" /> : null}
                <div className="text-center" data-id="element-88" data-mp="21amuh5blvkk8">
                  <dd className="font-display text-[28px] font-extrabold leading-none text-brand-yellow" data-id="element-89" data-mp="21bftfk4bp5rt">
                    <CountUp value={stat.value} data-id="element-90" data-mp="268oebsguvnwr" />
                  </dd>
                  <dt className="mt-1 text-xs text-white/60" data-id="element-91" data-mp="2b1r9g51a75f2">{stat.label}</dt>
                </div>
              </React.Fragment>)}
          </motion.dl>
        </motion.div>

        <motion.div id="cotizar" className="relative scroll-mt-28" initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-92" data-mp="2ky43x54nhnav">
          <div aria-hidden="true" className="absolute -inset-0.5 animate-pulse rounded-[26px] bg-[linear-gradient(135deg,#FFD500,#1B4DCC,#FFD500)] opacity-70" data-id="element-93" data-mp="2tx7nsbbn66qf" />
          <motion.span initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 1,
          duration: 0.5
        }} className="absolute -right-3 -top-4 z-10 inline-flex animate-float items-center gap-1.5 rounded-full bg-brand-green px-3.5 py-1.5 text-xs font-bold text-white shadow-lg" data-id="element-94" data-mp="znn8gewa0h0i">
            <BoltIcon sx={{
            fontSize: 15
          }} data-id="element-95" data-mp="9bs6117j9po8" />
            Respuesta en 24h
          </motion.span>
          <div className="relative rounded-3xl bg-white p-6 shadow-brand-lg sm:p-10" data-id="element-96" data-mp="3hr27c73lmquy">
            <LeadForm data-id="element-97" data-mp="3cs8ri80uanrm" />
          </div>
        </motion.div>
      </div>

      <motion.div aria-hidden="true" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.4
    }} className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-1 text-white/50 lg:flex" data-id="element-98" data-mp="3rftu80tsykz0">
        <span className="text-[11px] font-semibold uppercase tracking-[0.2em]" data-id="element-99" data-mp="2yxg30k2z1x8w">
          Desliza
        </span>
        <motion.span animate={{
        y: [0, 6, 0]
      }} transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-100" data-mp="19inky88tv32s">
          <KeyboardArrowDownIcon sx={{
          fontSize: 22
        }} data-id="element-101" data-mp="1ea5jyqraitl4" />
        </motion.span>
      </motion.div>
    </section>;
}